import "./datatable.scss";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  timetableMasterColumns,
  timetableMasterRows,
  fetchTimetableMasterRows,
} from "../../datatablesource";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../loader/Loader";
import { serverUrl } from "../../temp";
import { useSlug } from "../../SlugContext";
import { ToastContainer, toast } from "react-toastify";
import { Tooltip } from "@mui/material";

const TimeTableMasterDataTable = () => {
  const [data, setData] = useState(timetableMasterRows);
  const [loading, setLoading] = useState(false);
  const { slugs } = useSlug();
  const [roles, setRoles] = useState([]);
  const navigate = useNavigate();

  const getData = async () => {
    setLoading(true);
    const rows = await fetchTimetableMasterRows();
    setLoading(false);
    setData(Array.from(rows.data));
  };

  useEffect(() => {
    const roleString = localStorage.getItem("role_name") || "";
    const rolesArray = roleString.split(",").map((role) => role.trim());
    setRoles(rolesArray);
    getData();
  }, []);

  const handleStudentDownload = (timetableMasterId) => {
    if (!timetableMasterId) {
      toast.error("Timetable Master ID not found");
      return;
    }
    const downloadUrl = `${serverUrl}/download-timetable-without?timetable_master_id=${timetableMasterId}`;
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.target = "_blank";
    link.download = "student-timetable.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleAdminDownload = (timetableMasterId) => {
    if (!timetableMasterId) {
      toast.error("Timetable Master ID not found");
      return;
    }
    const downloadUrl = `${serverUrl}/download-timetable?timetable_master_id=${timetableMasterId}`;
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.target = "_blank";
    link.download = "admin-timetable.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleViewSlots = (id, class_id) => {
    localStorage.setItem("timetable_master", id);
    localStorage.setItem("timetable_master_class_id", class_id);
    navigate(`/time-table/time-table-slot/${id}`);
  };

  const handleActivate = async (id) => {
    try {
      setLoading(true);
      const response = await fetch(
        `${serverUrl}/activate_timetable_master/${id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!response.ok) throw new Error("Failed to activate timetable");

      await getData();
      toast.success("Timetable activated successfully!");
    } catch (error) {
      console.error("Error activating timetable:", error);
      toast.error("Failed to activate timetable");
    } finally {
      setLoading(false);
    }
  };

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 350,
      renderCell: (params) => {
        const isSlotsFull = params.row.isSlotsFull;
        const isUpcoming = params.row.is_upcoming;

        return (
          <div className="cellAction flex gap-2">
            {isUpcoming && (
              <Tooltip
                title={!isSlotsFull ? "Complete the slots first" : ""}
                arrow
              >
                <span>
                  <button
                    className="editButton"
                    onClick={() => handleActivate(params.row.id)}
                    disabled={!isSlotsFull || loading}
                    style={{
                      cursor:
                        !isSlotsFull || loading ? "not-allowed" : "pointer",
                    }}
                  >
                    Activate
                  </button>
                </span>
              </Tooltip>
            )}

            <button
              className="viewButton"
              onClick={() =>
                handleViewSlots(params.row.id, params.row.class_id)
              }
            >
              View Slots
            </button>

            {slugs && slugs.includes("Downloadtimetable") && !isUpcoming && (
              <>
                <Tooltip
                  title={!isSlotsFull ? "Complete the slots first" : ""}
                  arrow
                >
                  <span>
                    <button
                      className="leaveButton"
                      disabled={!isSlotsFull}
                      onClick={() => handleStudentDownload(params.row.id)}
                      style={{
                        cursor: !isSlotsFull ? "not-allowed" : "pointer",
                      }}
                    >
                      Notice-Board Timetable
                    </button>
                  </span>
                </Tooltip>

                <Tooltip
                  title={!isSlotsFull ? "Complete the slots first" : ""}
                  arrow
                >
                  <span>
                    <button
                      className="leaveButton"
                      disabled={!isSlotsFull}
                      onClick={() => handleAdminDownload(params.row.id)}
                      style={{
                        cursor: !isSlotsFull ? "not-allowed" : "pointer",
                      }}
                    >
                      Admin Timetable
                    </button>
                  </span>
                </Tooltip>
              </>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between w-full gap-3">
          <h2 className="title text-gray-700 text-2xl">Timetable</h2>
          {slugs && slugs.includes("Timetable-New") && (
            <Link
              to="/time-table/new"
              className="commonButton w-full sm:w-auto"
            >
              Add New
            </Link>
          )}
        </div>
      </div>

      {loading ? (
        <Loader fullScreen={false} />
      ) : (
        <DataGrid
          className="datagrid"
          rows={data}
          columns={timetableMasterColumns.concat(actionColumn)}
          pageSize={9}
          rowsPerPageOptions={[9]}
          components={{ Toolbar: GridToolbar }}
        />
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default TimeTableMasterDataTable;
